import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m16 3 4 4-4 4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20 7H4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m8 21-4-4 4-4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 17h16", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ArrowRightLeft";
const ArrowRightLeft = memo(themed(Icon));
export {
  ArrowRightLeft
};
//# sourceMappingURL=arrow-right-left.js.map
